import { useBulkUpdatePreflight } from '@aibees/elephant/hooks/people/use-bulk-update-preflight';
import { useEnrichPersonSaveRecord } from '@aibees/elephant/hooks/people/use-enrich-person-save-record';
import { memo } from 'react';
import { BulkUpdateDialog } from '../../../bulk-update-dialog';
import type { SavedRecordsUpdateDialogProps as Props } from './types';

/**
 * Binds one BULK_UPDATE_ACTIONS entry to its preflight and submit. Everything
 * that differs between the update actions lives in the config, not here.
 */
export const SavedRecordsUpdateDialog = memo(
  ({ className, open, onClose, config, table }: Props) => {
    const { rows, skipped, totalCost, eligible, isCalculating, failed } =
      useBulkUpdatePreflight(
        config.actions,
        config.rowKeys,
        open ? table : undefined
      );

    const { handleEnrich } = useEnrichPersonSaveRecord(
      config.actions,
      onClose,
      table,
      eligible
    );

    return (
      <BulkUpdateDialog
        className={className}
        open={open}
        onClose={onClose}
        icon={config.icon}
        title={config.label}
        selectedCount={table?.selection.included.length || 0}
        rows={rows}
        skipped={skipped}
        totalCost={totalCost}
        isCalculating={isCalculating}
        failed={failed}
        disableSubmit={isCalculating || failed || eligible === 0}
        // A failed estimation also leaves `eligible` at 0, so the empty-state
        // copy would otherwise claim these contacts need no updating.
        disabledHelperText={
          failed
            ? 'The cost estimation failed, so this update cannot be priced. Close the dialog and try again.'
            : config.emptyHelperText
        }
        onSubmit={handleEnrich}
      />
    );
  }
);

SavedRecordsUpdateDialog.displayName = 'SavedRecordsUpdateDialog';
